import env from 'shared/constants/env';

/**
 * Get the appropriate API endpoint based on the upgrade flag in localStorage
 * @returns {string} - Returns API_ENDPOINT_V2 if upgrade is true, otherwise API_ENDPOINT
 */
export const getApiEndpoint = () => {
  try {
    const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));
    const upgrade = user?.upgrade;

    // If upgrade is true, use v2 endpoint, otherwise use v1
    return upgrade === true ? env.API_ENDPOINT_V2 : env.API_ENDPOINT;
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    // Default to v1 endpoint if there's an error
    return env.API_ENDPOINT;
  }
};
